import { Axis } from 'types/Axis'
import { createAction } from 'typesafe-actions'

/** Update IAnswer action */
export const updateAnswer = createAction('answer/update', resolve => {
  return (questionIndex: number, answer: number, axis: Axis) =>
    resolve({
      answer,
      axis,
      questionIndex
    })
})
